import React, { useEffect } from "react";
import HeroSection from "../components/home/HeroSection";
import HowItWorksAlt from "../components/home/HowItWorksAlt";
import FeaturedJobs from "../components/home/FeaturedJobs";
import Testimonials from "../components/home/Testimonials";
import CTAWithFAQ from "../components/home/CTAWithFAQ";

export default function Home() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="">
      <HeroSection />

      <HowItWorksAlt />

      <FeaturedJobs />

      <Testimonials />

      <CTAWithFAQ />
    </div>
  );
}
